import React from "react";

const SurgeryIcon = ({
  className = "w-11 h-11",
  viewBox = "0 0 44 44",
  fill = "currentColor",
  stroke = "currentColor",
  strokeWidth = "2",
  ...props
}) => (
  <svg
    className={className}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37 5C38.657 5 40 6.343 40 8V36C40 37.657 38.657 39 37 39H7C5.343 39 4 37.657 4 36V8C4 6.343 5.343 5 7 5H37ZM36 9H8V35H36V9ZM28 13C29.105 13 30 13.895 30 15V19C30 20.105 29.105 21 28 21H16C14.895 21 14 20.105 14 19V15C14 13.895 14.895 13 16 13H28ZM26 17H18V19H26V17ZM28 25C29.105 25 30 25.895 30 27C30 28.105 29.105 29 28 29H16C14.895 29 14 28.105 14 27C14 25.895 14.895 25 16 25H28Z"
      fill={fill}
    />
  </svg>
);

export default SurgeryIcon;
